// @ts-nocheck

/**
 * Suppresses TypeScript errors for JSX imports of widgets with no type definitions.
 * TODO: Add type definitions for non-TypeScript widget components.
 */

// JSX imports of widget components
import TvActiveStocks from "../widget-components/third-party-widgets/TvActiveStocks";
import TvAdvancedRealTimeChart from "../widget-components/third-party-widgets/TvAdvancedRealTimeChart";
import TvMarketData from "../widget-components/third-party-widgets/TvMarketData";
import InvEconCalendar from "../widget-components/third-party-widgets/InvEconCalendar";
import BloombergLive from "../widget-components/third-party-widgets/BloombergTVWidget";
import BrokerTicket from "../widget-components/broker-ticket/BrokerTicket";
import BrokerPriceLadderSP from "../widget-components/broker-price-ladder/BrokerPriceLadderSP";
import BrokerPriceLadderNQ from "../widget-components/broker-price-ladder/BrokerPriceLadderNQ";
import BrokerPriceLadderYM from "../widget-components/broker-price-ladder/BrokerPriceLadderYM";

// Typescript Widgets
import EnergyTwitter from "../widget-components/energy-twitter/EnergyTwitter";
import FinTwitter from "../widget-components/fin-twitter/FinTwitter";
import EconomicCalendar from "../widget-components/economic-calendar";
import HeadlinesSearchForm from "../widget-components/newsquawk-headlines/HeadlinesSearchForm";
import React, { lazy } from "react";
import FirehoseSearchForm from "@/widget-components/firehose-widgets/firehose-all/FirehoseSearchForm";
import StocksRatingsSearchForm from "@/widget-components/firehose-widgets/stocks-ratings/StocksRatingsSearchForm";

export const componentMap = {
  TvActiveStocks: TvActiveStocks,
  TvAdvancedRealTimeChart: TvAdvancedRealTimeChart,
  InvEconCalendar: InvEconCalendar,
  BloombergLive: BloombergLive,
  EnergyTwitter: EnergyTwitter,
  FinTwitter: FinTwitter,
  BrokerTicket: BrokerTicket,
  EconomicCalendar: EconomicCalendar,
  TvMarketData: TvMarketData,
  BrokerPriceLadderSP: BrokerPriceLadderSP,
  BrokerPriceLadderYM: BrokerPriceLadderYM,
  BrokerPriceLadderNQ: BrokerPriceLadderNQ,
  TestComponent: lazy(
    () => import("../widget-components/test-component/TestComponent")
  ),
  CreateHeadline: lazy(async () => ({
    default: (
      await import("@/widget-components/create-headline/CreateHeadline")
    ).CreateHeadline,
  })),

  NewsquawkHeadlines: lazyWithStatic(
    () => import("@/widget-components/newsquawk-headlines/NewsquawkHeadlines"),
    { SearchComponent: HeadlinesSearchForm }
  ),

  FirehoseAll: lazyWithStatic(
    () =>
      import("../widget-components/firehose-widgets/firehose-all/FirehoseAll"),
    {
      SearchComponent: (props) => FirehoseSearchForm({ ...props }),
    }
  ),
  CryptoWeb: lazyWithStatic(
    () => import("../widget-components/firehose-widgets/crypto-web/CryptoWeb"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["crypto-web-news"],
          defaultTitle: "Crypto Blogs & Websites",
        }),
    }
  ),
  EnergyWeb: lazyWithStatic(
    () => import("../widget-components/firehose-widgets/energy-web/EnergyWeb"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["energy-web-news"],
          defaultTitle: "Energy Blogs & Websites",
        }),
    }
  ),
  TruthSocial: lazyWithStatic(
    () =>
      import("../widget-components/firehose-widgets/truth-social/TruthSocial"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["truth-social"],
          defaultTitle: "Truth Social",
        }),
    }
  ),
  EnergyX: lazyWithStatic(
    () => import("../widget-components/firehose-widgets/energy-x/EnergyX"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["energy-x"],
          defaultTitle: "Energy X (Twitter)",
        }),
    }
  ),
  StocksNews: lazyWithStatic(
    () =>
      import("../widget-components/firehose-widgets/stocks-news/StocksNews"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["stocks-one", "stocks-two", "stocks-three", "stocks-four", "stocks-four-filings"],
          defaultTitle: "Equities News",
        }),
    }
  ),
  FinX: lazyWithStatic(
    () => import("../widget-components/firehose-widgets/fin-x/FinX"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({ ...props, source: ["fin-x"], defaultTitle: "FinX" }),
    }
  ),
  GeneralWeb: lazyWithStatic(
    () =>
      import("../widget-components/firehose-widgets/general-web/GeneralWeb"),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["fin-web-news"],
          defaultTitle: "General Web",
        }),
    }
  ),
  FinancialReportsEU: lazyWithStatic(
    () =>
      import(
        "../widget-components/firehose-widgets/financial-reports-eu/FinancialReportsEU"
      ),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: ["stocks-five-eu"],
          defaultTitle: "Financial Reports EU",
        }),
    }
  ),
  ResearchHeadlines: lazy(
    () => import("../widget-components/research-headlines/")
  ),
  InsiderTransactionFeed: lazy(
    () => import("@/widget-components/equities-widgets/InsiderTransactionFeed")
  ),
  GovernmentTradeFeed: lazy(
    () => import("../widget-components/equities-widgets/GovernmentTradeFeed")
  ),
  OptionActivityFeed: lazy(
    () => import("../widget-components/equities-widgets/OptionActivityFeed")
  ),
  BlockTradeFeed: lazy(
    () => import("../widget-components/equities-widgets/BlockTradeFeed")
  ),
  Sec13FStocksFeed: lazy(
    () => import("../widget-components/equities-widgets/Sec13FStocksFeed")
  ),
  StocksRatings: lazyWithStatic(
    () => import("../widget-components/firehose-widgets/stocks-ratings"),
    {
      SearchComponent: StocksRatingsSearchForm,
    }
  ),
  USTraderNews: lazyWithStatic(
    () =>
      import(
        "../widget-components/firehose-widgets/us-trader-news/UsTraderNews"
      ),
    {
      SearchComponent: (props) =>
        FirehoseSearchForm({
          ...props,
          source: [
            "stocks-four",
            "stocks-four-fedspeak",
            "stocks-four-general",
            "stocks-four-filings",
          ],
          defaultTitle: "Trade Xchange",
        }),
    }
  ),
  SecFilings: lazy(() => import("../widget-components/sec-filings/SecFilings")),
  SecFilingStories: lazy(() => import("../widget-components/sec-filings/SecFilingStories")),
  SecFilingActivity: lazy(() => import("../widget-components/sec-filings/SecFilingActivity")),
  SecStockFlow: lazy(() => import("../widget-components/sec-filings/SecStockFlow")),
  FundingDashboard: lazy(
    () => import("@/widget-components/funding-dashboard")
  ),
  UsMacroData: lazy(() => import("@/widget-components/us-macro-data")),
  MarketSnapshot: lazy(
    () =>
      import("@/widget-components/market-snapshot/MarketSnapshotViewer")
  ),
  MarketSnapshotAdmin: lazy(
    () =>
      import("@/widget-components/market-snapshot/MarketSnapshotAdmin")
  ),
};

export function lazyWithStatic<
  T extends React.ComponentType<any>,
  S extends Record<string, any>,
>(
  importer: () => Promise<{ default: T }>,
  staticProps: S
): LazyExoticComponent<T> & S {
  const LazyComponent = React.lazy(importer) as LazyExoticComponent<T> & S;
  Object.assign(LazyComponent, staticProps);
  return LazyComponent;
}
